<div class="container-fluid" *ngIf="!isAspirante">
  <!-- start page title -->
  <div class="row">
    <div class="col-12">
        <div class="page-title-box">
            <div class="page-title-right">
              <a href="#/panel-admin" class="btn btn-primary">
                Volver
              </a>
            </div>
            <h3 class="page-title">Contratación de Aspirantes | Oferta de la Entidad de Trabajo</h3>
        </div>
    </div>
  </div>

  <div class="row" style="overflow-x: scroll;">
    <div class="col-12">
      <div class="card" style="border-color: white;">
        <div class="card-body" style="margin-bottom: 150px;">
          <!-- Invoice Logo-->
          <div class="row">
            <div class="col-md-6">
              <label for="estadol" class="col-form-label">Busqueda</label>
              <input
                class="form-control"
                type="text"
                id="buscar"
                placeholder="Buscar organización..."
                [(ngModel)]="searchTerm"
                (input)="buscarOrganizacion()"
              >
            </div>
          </div>

          <hr class="text-dark">
          <div class="row">
            <div class="col-12">

              <table class="table">
                <thead>
                  <tr class="table-primary">
                    <th scope="col">N°</th>
                    <th scope="col">Organización</th>
                    <th scope="col">Acción</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let r of filteredResultado; let i = index">
                    <th scope="row">{{i+1}}</th>
                    <td>{{r.organizacion}}</td>
                    <td>
                      <a style="cursor: pointer;" class="btn btn-sm btn-primary" (click)="litarAspirantes(r.participantes, r.organizacion, r.sucursal)">Seleccionar</a>
                    </td>
                  </tr>
                </tbody>
              </table>


            </div>
          </div>
        </div> <!-- end card-body-->
      </div> <!-- end card -->
    </div> <!-- end col-->
  </div>

</div>

<app-modal [titulo]="titulo" [tipo_color]="tipo_color" [letra_color]="letra_color" [mensaje]="mensaje"></app-modal>

<app-lista-aspirante *ngIf="isAspirante"
[organizacion] = 'nombreOrganizacionb'
[aspirantes] = 'datosAspirante'
[sucursal] = 'sucursal'
(atras)="voler($event)">
</app-lista-aspirante>
